<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('parameter')"
                        :isNewButton="checkPermission('parameter_store')"
                        :otherButton="{ show: checkPermission('parameteritem_excelimport'), title: $t('bulk_import_button'), icon: 'ri-upload-line', emit: 'import-button-click' }"
                        @new-button-click="createFormShow"
                        @import-button-click="importFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('parameter')"
                              :isNewButton="checkPermission('parameter_store')"
                              :otherButton="{ show: checkPermission('parameteritem_excelimport'), title: $t('bulk_import_button'), icon: 'ri-upload-line', emit: 'import-button-click' }"
                              @new-button-click="createFormShow"
                              @import-button-click="importFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
            >
                <b-row>
                    <b-col sm="6">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('code')">
                            <b-form-input v-model="datatable.queryParams.filter.code_like">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>

            <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('parameter_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>

            <CommonModal ref="createFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('parameter_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('parameter_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>

            <CommonModal ref="importFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('parameteritem_excelimport')">
                <template v-slot:CommonModalTitle>
                    {{ $t('bulk_import_button').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <import-form @successProcess="importFormSuccess" v-if="formProcess=='import'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout";
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import CommonModal from "@/components/elements/CommonModal";
    //Other
    import qs from "qs";
    //Service
    import ParameterService from "@/services/ParameterService";
    //Page
    import CreateForm from "./CreateForm"
    import UpdateForm from "./UpdateForm"
    import ShowForm from "./ShowForm"
    import ImportForm from "./ImportExcel"


    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,

            CreateForm,
            UpdateForm,
            ShowForm,
            ImportForm
        },
        metaInfo() {
            return {
                title: this.$t("parameter"),
            };
        },
        data() {
            return {
                selectCode: null,
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            sortable: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'parameter_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t("edit"),
                                    class: "ri-edit-box-line",
                                    permission: 'parameter_update',
                                    callback: (row) => {
                                        this.loadData(row.id);
                                    },
                                },
                                {
                                    text: this.$t("delete"),
                                    class: "ri-delete-bin-2-line",
                                    permission: 'parameter_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    },
                                },
                                {
                                    text: this.$t("parameter_items"),
                                    class: "ri-list-check ",
                                    permission: 'parameter_showitems',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.openParameter(row.id);
                                    },
                                },
                            ],
                        },
                        {
                            label: this.$t("id"),
                            field: "id",
                            sortable: true,
                        },
                        {
                            label: this.$t("code"),
                            field: "code",
                            sortable: true,
                        },
                        {
                            label: this.$t("name"),
                            field: "name",
                            sortable: true,
                        },
                        {
                            label: this.$t("name_en"),
                            field: "name_en",
                            sortable: false,
                        },
                        {
                            label: this.$t("type"),
                            field: "type",
                            sortable: false,
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: "id",
                        page: 1,
                        limit: 20,
                    },
                },
            };
        },
        methods: {
            openParameter() {
                if (this.formId > 0) {
                    this.$router.push("/parameter/items/" + this.formId);
                }
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };

                return ParameterService.getAll(config).then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },
            loadData(id) {
                this.formProcess = "update";
                this.formId = id;
                ParameterService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t("api." + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.deleteModal(() => {
                    ParameterService.deleteParameter(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t("api." + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t("api." + error.data.message));
                                    });
                });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            importFormShow() {
                this.formId = null;
                this.formProcess = 'import';
                this.$refs.importFormModal.$refs.commonModal.show();
            },
            importFormSuccess() {
                this.$refs.importFormModal.$refs.commonModal.hide();
                this.getRows();
                this.formClear();
            },
        },
    };
</script>

